export default "__VITE_ASSET__DR7v$SHW__"